function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './StepsProvider.css';
import React from 'react';
import { PassportDetails, ApplicantDetails, PaymentSubmit } from './StepsTemplates';
import { getDictionaryItem } from '../../../utils';
import UploadDocuments from './StepsTemplates/UploadDocuments';
import { Translate } from './actions';
const StepsProvider = props => {
  const {
    currentStepId,
    context,
    updateContext,
    steps,
    apiConfig,
    getLookupOptions
  } = props;
  const setTranslateValue = async (relatedName, value) => {
    const field = context[relatedName];

    // api call
    const newVal = await Translate(apiConfig, value);
    updateContext({
      [relatedName]: _objectSpread(_objectSpread({}, field), {}, {
        value: newVal,
        valid: true
      })
    });
  };
  const GenerateStepData = (fieldsList, dictionary) => {
    fieldsList.forEach(_ref => {
      let {
        selectOptionName,
        apiName,
        name,
        type,
        required,
        relatedFieldName,
        options = [],
        replacedFieldName,
        staticName = ''
      } = _ref;
      const fieldName = apiName || replacedFieldName || name;
      const currentField = context[fieldName];
      if (currentField && currentField.name) return;
      switch (type) {
        case 'select':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value.toString() || '',
                name: fieldName,
                label: getDictionaryItem(dictionary, name) || staticName,
                required,
                selectOptionName,
                options: selectOptionName && getLookupOptions && getLookupOptions(selectOptionName) || currentField && currentField.options || options || [],
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
        case 'text':
          {
            console.log(fieldName, currentField && currentField.valid || !required);
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || '',
                name: fieldName,
                type,
                label: getDictionaryItem(dictionary, name) || staticName,
                required,
                relatedFieldName,
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
        case 'email':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || '',
                name: fieldName,
                type,
                label: getDictionaryItem(dictionary, name),
                required,
                relatedFieldName,
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
        case 'date':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || '',
                name: fieldName,
                label: getDictionaryItem(dictionary, name) || staticName,
                required,
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
        case 'phone':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || '',
                name: fieldName,
                label: getDictionaryItem(dictionary, name),
                required
              }
            });
            break;
          }
        case 'checkbox':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || false,
                name: fieldName,
                label: getDictionaryItem(dictionary, name) || staticName,
                required,
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
        case 'radio':
          {
            updateContext({
              [fieldName]: {
                value: currentField && currentField.value || '',
                name: fieldName,
                label: getDictionaryItem(dictionary, name),
                required,
                options,
                valid: currentField && currentField.valid || !required
              }
            });
            break;
          }
      }
    });
  };
  const getTranslateValue = async (name, relatedName) => {
    const field = context[name];
    const relatedField = context[relatedName];
    const value = relatedField.value;
    if (!value.length) return;
    const newVal = await Translate(apiConfig, value);
    updateContext({
      [name]: _objectSpread(_objectSpread({}, field), {}, {
        value: newVal,
        valid: true
      })
    });
  };
  const validateCurrentFields = fieldsList => {
    const invalidFields = fieldsList.find(_ref2 => {
      let {
        apiName,
        name,
        required
      } = _ref2;
      const currentName = apiName && apiName.length && apiName || name;
      if (!required) return false;
      if (!context[currentName]) return true;
      return !context[currentName].valid;
    });
    console.log(invalidFields);
    return !!invalidFields;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} `
  }, (() => {
    switch (currentStepId) {
      case 0:
        return /*#__PURE__*/React.createElement(PassportDetails, _extends({}, props, {
          stepConfig: steps[0],
          validateCurrentFields: validateCurrentFields,
          setTranslateValue: setTranslateValue,
          getTranslateValue: getTranslateValue,
          generateStepData: GenerateStepData
        }));
      case 1:
        return /*#__PURE__*/React.createElement(ApplicantDetails, _extends({}, props, {
          stepConfig: steps[1],
          validateCurrentFields: validateCurrentFields,
          setTranslateValue: setTranslateValue,
          getTranslateValue: getTranslateValue,
          generateStepData: GenerateStepData
        }));
      case 2:
        return /*#__PURE__*/React.createElement(UploadDocuments, _extends({}, props, {
          stepConfig: steps[2],
          documents: props.documents
        }));
      case 3:
        return /*#__PURE__*/React.createElement(PaymentSubmit, _extends({}, props, {
          stepConfig: steps[3]
        }));
    }
  })());
};
export default StepsProvider;
const commonStyles = "c1bdjmm9";